export enum OvaticCartState {
    UNKNOWN = 'UNKNOWN',
    ACTIVE = 'ACTIVE',
    CANCELLED = 'CANCELLED',
    CONFIRMED = 'CONFIRMED'
}
